export const FETCH_INGREDIENT_SPECIAL_CASES = {
  START: 'START_FETCH_INGREDIENT_SPECIAL_CASES',
  COMPLETE: 'COMPLETE_FETCH_INGREDIENT_SPECIAL_CASES',
  FAIL: 'FAIL_FETCH_INGREDIENT_SPECIAL_CASES',
  CLEANUP: 'CLEANUP_FETCH_INGREDIENT_SPECIAL_CASES',
}

export const DELETE_INGREDIENT_SPECIAL_CASE = {
  START: 'START_DELETE_INGREDIENT_SPECIAL_CASE',
  COMPLETE: 'COMPLETE_DELETE_INGREDIENT_SPECIAL_CASE',
  FAIL: 'FAIL_DELETE_INGREDIENT_SPECIAL_CASE',
}
